import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=5997c884&scoped=true"
import script from "./LoginForm.ts?vue&type=script&lang=ts&external"
export * from "./LoginForm.ts?vue&type=script&lang=ts&external"
import style0 from "./LoginForm.scss?vue&type=style&index=0&id=5997c884&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5997c884",
  null
  
)

export default component.exports